export default "__VITE_PUBLIC_ASSET__310cef1d__"